import { motion } from "framer-motion";

import { POINTS } from "../utils/Constant";

const containerVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};

const pointVariants = {
  hidden: { opacity: 0, y: 8 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

export default function InventoryGrid() {
  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="show"
      className="w-full max-w-md"
    >
      <p className="mb-4 font-['IBM_Plex_Mono'] text-[10px] uppercase tracking-[0.25em] text-slate-500">
        Why labs use KSAS
      </p>

      <div className="space-y-3.5">
        {POINTS.map(({ icon: Icon, title, desc }) => (
          <motion.div
            key={title}
            variants={pointVariants}
            className="group flex items-start gap-3 rounded-md border border-white/[0.06] bg-white/[0.02] p-3 transition-colors duration-200 hover:border-[#5B7CFF]/25 hover:bg-white/[0.04]"
          >
            <div className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-[#5B7CFF]/20 bg-[#5B7CFF]/10 text-[#8CA0FF] transition-colors duration-200 group-hover:bg-[#5B7CFF]/20">
              <Icon size={14} />
            </div>
            <div className="min-w-0">
              <p className="text-[13px] font-medium leading-tight text-white">
                {title}
              </p>
              <p className="mt-1 text-[12px] leading-relaxed text-slate-400">
                {desc}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}